import React from "react";
import { FacebookIcon, InstagramIcon, LinkedinIcon, MessageCircleIcon } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { company, images } from "../i18n/translations";
const quickLinks = [{
  id: "inicio",
  href: "#inicio"
}, {
  id: "nosotros",
  href: "#nosotros"
}, {
  id: "capacidad",
  href: "#capacidad"
}, {
  id: "galeria",
  href: "#galeria"
}, {
  id: "contacto",
  href: "#contacto"
}] as const;
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full bg-black text-slate-300" data-id="element-17" data-mp="37o7wzgy05fh">
      <div className="max-w-content mx-auto px-4 sm:px-6 py-16" data-id="element-18" data-mp="3lecb2jsfmiii">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4" data-id="element-19" data-mp="3ldu8l5f6f825">
          {/* Brand */}
          <div data-id="element-20" data-mp="3qbvm7atu2f68">
            <img src="https://cdn.magicpatterns.com/uploads/nMs7chRckPuBx9PPhJVEqo/image.png" alt="Símbolo GRANSACA" className="h-12 w-auto" width={130} height={58} data-id="element-21" data-mp="3qfji2gmr3do4" />
            <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-xs" data-id="element-22" data-mp="3l8qv40rs6dpv">{t.footer.tagline}</p>
            <div className="mt-5 flex items-center gap-3" data-id="element-23" data-mp="3gb8x35faxiwn">
              {[FacebookIcon, InstagramIcon, LinkedinIcon, MessageCircleIcon].map((Icon, i) => <a key={i} href={i === 3 ? company.whatsappLink : "#"} target={i === 3 ? "_blank" : undefined} rel="noreferrer" aria-label="Social" className="flex h-9 w-9 items-center justify-center rounded-sm bg-white/5 text-slate-300 transition-colors hover:bg-orange hover:text-white" data-id="element-24" data-mp="3v5dfypk3x4rw" data-mpi={i}>
                  <Icon size={18} data-id="element-25" data-mp="cu0fmmohkl2g" />
                </a>)}
            </div>
          </div>

          {/* Quick links */}
          <div data-id="element-26" data-mp="qujkxm1khd0x">
            <h3 className="font-heading font-bold uppercase text-white text-lg tracking-wide" data-id="element-27" data-mp="qu1exxp3rkft">
              {t.footer.quickLinks}
            </h3>
            <ul className="mt-4 space-y-2.5" data-id="element-28" data-mp="tvcydolszzdk">
              {quickLinks.map(l => <li key={l.id} data-id="element-29" data-mp="yu7gspfuzlx5">
                  <a href={l.href} className="text-sm text-slate-400 transition-colors hover:text-orange" data-id="element-30" data-mp="ytek6ham6csq">
                    {t.nav[l.id]}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Products */}
          <div data-id="element-31" data-mp="18lu1rdi00zd3">
            <h3 className="font-heading font-bold uppercase text-white text-lg tracking-wide" data-id="element-32" data-mp="1cluodlf94gv8">
              {t.footer.productsTitle}
            </h3>
            <ul className="mt-4 space-y-2.5" data-id="element-33" data-mp="1hj4c8wmzskgy">
              {t.products.items.slice(0, 6).map(p => <li key={p.name} data-id="element-34" data-mp="1mkjw4ldfokxr">
                  <a href="#productos" className="text-sm text-slate-400 transition-colors hover:text-orange" data-id="element-35" data-mp="1riv9v76unfl9">
                    {p.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-36" data-mp="3tarr8xfp7jny">
            <h3 className="font-heading font-bold uppercase text-white text-lg tracking-wide" data-id="element-37" data-mp="3tccc1vc7no8m">
              {t.footer.contactTitle}
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400" data-id="element-38" data-mp="25o57sdb3bha1">
              <li className="font-medium text-slate-300" data-id="element-39" data-mp="21mthe5ke6s0s">{company.legalName}</li>
              <li data-id="element-40" data-mp="21kpglwhsi94q">
                <a href={`tel:${company.phone}`} className="hover:text-orange transition-colors" data-id="element-41" data-mp="1wnp536268e68">
                  {company.phone}
                </a>
              </li>
              <li data-id="element-42" data-mp="2td6k4bn1nckl">
                <a href={`mailto:${company.email}`} className="hover:text-orange transition-colors" data-id="element-43" data-mp="2pcectnxqfhqy">
                  {company.email}
                </a>
              </li>
              <li data-id="element-44" data-mp="2kbglakqu1bcs">{t.contact.address}</li>
              <li className="text-orange font-semibold pt-1" data-id="element-45" data-mp="2fegn0w085cw8">{company.website}</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-46" data-mp="18yxlv46k765l">
        <div className="max-w-content mx-auto px-4 sm:px-6 py-6 text-center text-xs text-slate-500 leading-relaxed" data-id="element-47" data-mp="13z1klcp8xstq">
          © 2026 {company.website} · {company.legalName} · {t.footer.rights}
        </div>
      </div>
    </footer>;
}